import { useMutation, useQuery } from '@tanstack/react-query';
import { finalRiskApi } from '../../apis';
import { InternalApiBulkRiskOverrideCommand, InternalApiFinalRiskOverrideReason } from '../../api-internal';

const fetchAllOverrideReasons = async () => {
  let page = 0;
  const pageSize = 50;
  let hasNextPage = true;
  let allReasons: InternalApiFinalRiskOverrideReason[] = [];

  while (hasNextPage) {
    const reasonPage = await finalRiskApi.findAllOverrideReasons({ page, size: pageSize });
    allReasons = allReasons.concat(reasonPage.content);
    hasNextPage = reasonPage.total > allReasons.length && reasonPage.size != 0;
    page += 1;
  }

  return allReasons;
};

export const useOverrideReasons = () => {
  return useQuery({
    queryKey: ['bulkRiskOverrideReasons'],
    queryFn: fetchAllOverrideReasons,
  });
};

export const useBulkOverride = () => {
  return useMutation({
    mutationFn: (command: InternalApiBulkRiskOverrideCommand) =>
      finalRiskApi.bulkOverride({
        internalApiBulkRiskOverrideCommand: command,
      }),
  });
};
